import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import useTokenRefresher from "../../hooks/useTokenRefresher";
import SessionExpiryModal from "../SessionExpiryModal/SessionExpiryModal";
import AuthLayout from "../../layouts/AuthLayout";
import ForcePasswordChange from "../ForcePasswordChange/ForcePasswordChange";
import { MUST_CHANGE_PASSWORD_KEY } from "../../utils/methods";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("authToken");
  const [mustChangePassword, setMustChangePassword] = useState(
    () => localStorage.getItem(MUST_CHANGE_PASSWORD_KEY) === "true",
  );
  useTokenRefresher();

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Rendered instead of the page (and its layout) so nothing else loads —
  // gs.be would 403 those calls anyway until the password is changed.
  if (mustChangePassword) {
    return (
      <>
        <AuthLayout>
          <ForcePasswordChange
            onDone={() => {
              localStorage.removeItem(MUST_CHANGE_PASSWORD_KEY);
              setMustChangePassword(false);
            }}
          />
        </AuthLayout>
        <SessionExpiryModal />
      </>
    );
  }

  return (
    <>
      {children}
      <SessionExpiryModal />
    </>
  );
};

export default ProtectedRoute;

// import React, { useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
// import { verifyToken } from "./methods";

// const ProtectedRoute = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);

//   useEffect(() => {
//     const token = localStorage.getItem("authToken");

//     if (token) {
//       verifyToken(token)
//         .then((isValid) => {
//           setIsAuthenticated(isValid);
//         })
//         .catch(() => {
//           setIsAuthenticated(false);
//         });
//     } else {
//       setIsAuthenticated(false);
//     }
//   }, []);

//   if (!isAuthenticated) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;
